import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { createMarkup, relativizeURL } from 'lib/Utils'
import $ from 'jquery'
import { TweenMax, Power0, Power2 } from 'gsap'
import SplitText from 'lib/SplitText'

// Components
import NavArrows from 'components/NavArrows'

// Styles
import './index.scss'

class ServicesNav extends Component {
  constructor (props) {
    super(props)
    const serviceTitle = (this.props.selectedService && this.props.services) ? this.getServiceTitle(this.props.selectedService) : null
    this.state = { serviceTitle, direction: 1 }
    this.onWindowScroll = this.onWindowScroll.bind(this)
  }

  getCurrentServiceIndex () {
    return this.getServiceIndex(this.props.selectedService)
  }

  getServiceIndex (serviceID) {
    return this.props.services.findIndex((service) => { return service.ID === serviceID })
  }

  hasServiceRelatedProps (props = this.props) {
    return (props.services !== null && props.services.length > 0 && props.selectedService !== null)
  }

  getServiceTitle (serviceID) {
    const selectedServiceObj = this.props.services.find((service) => { return service.ID === serviceID })
    let toReturn = null
    if (selectedServiceObj) {
      toReturn = selectedServiceObj.title
    }

    return toReturn
  }

  renderCounter () {
    if (this.hasServiceRelatedProps()) {
      const serviceIndex = this.getCurrentServiceIndex()
      return (
        <div className='services-nav__counter'>
          <span className='active'>{String('00' + (serviceIndex + 1)).slice(-2)}</span>
          <span className='separator' />
          <span className='total'>{String('00' + this.props.services.length).slice(-2)}</span>
        </div>
      )
    } else {
      return null
    }
  }

  getAdjacentServiceURL (next = true) {
    if (this.hasServiceRelatedProps()) {
      const serviceIndex = this.getCurrentServiceIndex()
      let URL = null
      if (next) {
        if (serviceIndex === this.props.services.length - 1) {
          URL = this.props.services[0].url
        } else {
          URL = this.props.services[serviceIndex + 1].url
        }
      } else {
        if (serviceIndex === 0) {
          URL = this.props.services[this.props.services.length - 1].url
        } else {
          URL = this.props.services[serviceIndex - 1].url
        }
      }
      return relativizeURL(URL)
    } else {
      return null
    }
  }

  getDirection (currentIndex, nextIndex) {
    if (currentIndex < nextIndex || nextIndex === 0) {
      return 1
    } else {
      return -1
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.hasServiceRelatedProps(nextProps) && nextProps.selectedService !== this.props.selectedService) {
      if (this.props.selectedService === null) {
        this.setState({ serviceTitle: this.getServiceTitle(nextProps.selectedService) })
      } else {
        const direction = this.getDirection(
          this.getServiceIndex(this.props.selectedService),
          this.getServiceIndex(nextProps.selectedService)
        )
        const $titleEl = $(this.component).find('.services-nav__title')
        if ($titleEl.find('.line').length === 0) {
          const splitText = new SplitText($titleEl, { type: 'lines', linesClass: 'line-wrapper' })
          splitText.lines.forEach(function (line) {
            $(line).wrapInner('<div class=\'line\'></div>')
          })
        }
        TweenMax.to($titleEl.find('.line'), 0.5, {
          opacity: 0,
          y: `${100 * direction * -1}%`,
          ease: Power2.easeIn,
          onComplete: () => {
            this.setState({ serviceTitle: this.getServiceTitle(nextProps.selectedService), direction })
          }
        })
      }
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.serviceTitle !== prevState.serviceTitle) {
      const $titleEl = $(this.component).find('.services-nav__title')
      const splitText = new SplitText($titleEl, { type: 'lines', linesClass: 'line-wrapper' })
      splitText.lines.forEach(function (line) {
        $(line).wrapInner('<div class=\'line\'></div>')
      })
      TweenMax.fromTo(
        $titleEl.find('.line'),
        0.5,
        {
          opacity: 0,
          y: `${30 * this.state.direction}px`
        },
        {
          opacity: 1,
          y: '0px',
          ease: Power2.easeOut,
        }
      )
    }
  }

  componentWillEnter (callback) {
    TweenMax.fromTo(this.component, 0.6, { opacity: 0 }, { opacity: 1, ease: Power0.easeNone, onComplete: callback, delay: 1 })
  }

  componentWillLeave (callback) {
    TweenMax.fromTo(this.component, 0.6, { opacity: 1 }, { opacity: 0, ease: Power0.easeNone, onComplete: callback })
  }

  componentDidMount () {
    $(window).on('scroll', this.onWindowScroll)
  }

  componentWillUnmount () {
    $(window).off('scroll', this.onWindowScroll)
  }

  onWindowScroll (event) {
    if (window.innerWidth >= 1024) {
      TweenMax.to(this.el, 0.6, { autoAlpha: 1, ease: Power0.easeNone })
    } else {
      TweenMax.to(
        this.componentInner,
        0.6,
        { autoAlpha: Math.max(0, Math.min(1, (150 - $(window).scrollTop()) / 150)), ease: Power0.easeNone }
      )
    }
  }

  render () {
    return (
      <div ref={el => { this.component = el }} className='services-nav'>
        <NavArrows prevURL={this.getAdjacentServiceURL(false)} nextURL={this.getAdjacentServiceURL()} />
        <div ref={el => { this.componentInner = el }} className='services-nav__inner'>
          {this.renderCounter()}
          <h1 className='services-nav__title' dangerouslySetInnerHTML={createMarkup(this.state.serviceTitle)} />
        </div>
      </div>
    )
  }
}

ServicesNav.propTypes = {
  services: PropTypes.array,
  selectedService: PropTypes.number
}

export default ServicesNav



// WEBPACK FOOTER //
// ./src/components/ServicesNav/index.js